/** Pufien beden rehberi modalı — native <dialog>, ek kütüphane yok. */
(function () {
  function bind(root) {
    (root || document).querySelectorAll('[data-pf-sizeguide-open]').forEach(function (btn) {
      if (btn.dataset.pfBound === '1') return;
      btn.dataset.pfBound = '1';

      btn.addEventListener('click', function () {
        var dlg = document.getElementById(btn.getAttribute('data-pf-sizeguide-open'));
        if (!dlg) return;
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.setAttribute('open', '');
      });
    });

    (root || document).querySelectorAll('[data-pf-sizeguide-close]').forEach(function (btn) {
      if (btn.dataset.pfBound === '1') return;
      btn.dataset.pfBound = '1';
      btn.addEventListener('click', function () {
        var dlg = btn.closest('dialog');
        if (dlg) dlg.close();
      });
    });

    // Arka plana tıklayınca kapansın
    (root || document).querySelectorAll('dialog.pf-sizeguide').forEach(function (dlg) {
      if (dlg.dataset.pfBound === '1') return;
      dlg.dataset.pfBound = '1';
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
